import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { hasRoleLandlord } from 'common/userRoles';

import useBranch from 'client/hooks/useBranch';

import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREEN,
  SR_BUTTON_HEIGHT_TALL,
} from 'client/components/SrButton/SrButton';
import SrPartnerBankAccountInviteModal from 'client/components/SrPartnerBankAccount/SrPartnerBankAccountInviteModal';

const SrPartnerConnectBankAccountButton = ({ partner, listing, householdListingId }) => {
  const connectBankAccountFormUrl = `/partner/${partner.slug}/listing/${listing.id}/connect-bank/${householdListingId}`;

  const history = useHistory();
  const { currentUser } = useBranch({
    currentUser: ['currentUser'],
  });

  const [partnerBankAccountInviteModalIsOpen, setPartnerBankAccountInviteModalIsOpen] = useState(
    false,
  );

  const onClickButton = () => {
    if (hasRoleLandlord(currentUser.roles)) {
      history.push(connectBankAccountFormUrl);
    } else {
      setPartnerBankAccountInviteModalIsOpen(true);
    }
  };

  return (
    <>
      <SrButton
        theme={SR_BUTTON_THEME_ADOBE_GREEN}
        heightType={SR_BUTTON_HEIGHT_TALL}
        hasBoxShadow
        boxShadow="0px 8px 17px rgba(0, 162, 56, 0.43)"
        onClick={onClickButton}
      >
        Collect Funds
      </SrButton>
      {partnerBankAccountInviteModalIsOpen && (
        <SrPartnerBankAccountInviteModal
          connectBankAccountFormUrl={connectBankAccountFormUrl}
          listing={listing}
          onClose={() => {
            setPartnerBankAccountInviteModalIsOpen(false);
          }}
        />
      )}
    </>
  );
};

SrPartnerConnectBankAccountButton.propTypes = {
  partner: PropTypes.object.isRequired,
  listing: PropTypes.object.isRequired,
  householdListingId: PropTypes.number.isRequired,
};

SrPartnerConnectBankAccountButton.displayName = 'SrPartnerConnectBankAccountButton';

export default SrPartnerConnectBankAccountButton;
